import React from 'react';

import {
  Drawer as ChakraDrawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
} from '@chakra-ui/react';

import { StyledDrawerCloseButton } from 'uiToolkitV1/TabbedDrawer/TabbedDrawer.styles';

// Styles

function Drawer({ isOpen = false, size = 'md', onClose, header, footer, children }) {
  return (
    <ChakraDrawer isOpen={isOpen} placement="right" size={size} onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent w="40%" minWidth="300px" maxW="40%">
        <StyledDrawerCloseButton />
        {header ? <DrawerHeader p={0}>{header}</DrawerHeader> : null}

        <DrawerBody p="0">{children}</DrawerBody>

        {footer ? <DrawerFooter>{footer}</DrawerFooter> : null}
      </DrawerContent>
    </ChakraDrawer>
  );
}

export { Drawer };
